export const formatNumberDigits = (
  number,
  locale,
  maximumSignificantDigits
) => {
  return new Intl.NumberFormat(locale, {
    maximumSignificantDigits,
  }).format(number)
}
